import { GetterTree } from 'vuex';
import { Store } from '@/store/types';
import { Feature } from '@/helpers/data';
import { AuthenticationState } from '../types';

export const authenticationGetters: GetterTree<AuthenticationState, Store> = {

  isFeatureEnabled(state): (feature: Feature) => boolean {
    return (feature) => state.user.enabledFeatures.includes(feature);
  },

  isAdmin(state): boolean {
    return state.user.roles.includes('ROLE_ADMIN');
  },

};
